import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-wide, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubbleWide"><path d="M22 3.00002L2 3V19L8.83366 19L11.996 21.6509L15.1957 19H22V3.00002Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleWide;
